module.exports = __webpack_public_path__ + "static/media/blackdreadextension.3510d502.jpg";